import ReactPDF, { View } from '@react-pdf/renderer';
import React from 'react';
import Dialog from 'src/components/common/Dialog';
import DialogList from 'src/dialogs';
import { Page, Text, Document, StyleSheet } from '@react-pdf/renderer';
import { Font } from '@react-pdf/renderer';
import Arial from 'src/components/project/sections/LeasingComponents/BrineTemplates/arial.ttf';
import ArialBold from 'src/components/project/sections/LeasingComponents/BrineTemplates/arialbd.ttf';
Font.register({ family: 'Arial', src: Arial});
Font.register({ family: 'Arial-Bold', src: ArialBold});
import { useDispatch } from 'react-redux';
import actions from 'src/actions';
// import LeaseClause from 'src/models/LeaseClause';
// import MathUtil from 'src/util/MathUtil';
// import Acknowledgement from 'src/models/leasing/Acknowledgement';
// import SignatureBlock from 'src/models/leasing/SignatureBlock';
import SaltwerxBrineLeaseProps from 'src/models/leaseTemplateProps/SaltwerxBrineLeaseProps';
// tslint:disable: max-line-length

const styles = StyleSheet.create({
    pageMain: {
        backgroundColor: '#FFFFFF',
        paddingTop: '0.5in',
        paddingBottom: '1in',
        paddingHorizontal: '0.5in',
        paddingLeft: '1in',
        paddingRight: '1in',
        fontFamily: 'Helvetica',
    },
    page: {
        backgroundColor: '#FFFFFF',
        paddingTop: '0.54in',
        paddingHorizontal: '0.5in',
        paddingLeft: '1in',
        paddingRight: '1in',
    },
    pageNumbers: {
        position: 'absolute',
        bottom: '.6in',
        left: 0,
        right: '1in',
        textAlign: 'right',
        fontSize: 10,
        color: '#8e9094',
    },
    section: {
        margin: 10,
        padding: 10,
        flexGrow: 1,
    },
    bold: {
        fontFamily: 'Helvetica-Bold',
    },
    fontNormal: {
        fontWeight: 'normal',
        fontSize: '10pt',
    },
    mt0: {
        marginTop: 0,
    },
    mt1: {
        marginTop: 10,
    },
    mt2: {
        marginTop: 20,
    },
    mt3: {
        marginTop: 30,
    },
    mt4: {
        marginTop: 40,
    },
    mb1: {
        marginBottom: 10,
    },
    mb2: {
        marginBottom: 20,
    },
    mr1: {
        marginRight: 5,
    },
    mr2: {
        marginRight: 20,
    },
    ml1: {
        marginLeft: 5,
    },
    ml2: {
        marginLeft: 20,
    },
    ml3: {
        marginLeft: 30,
    },
    indent: {
        textIndent: '.45in',
    },
    center: {
        textAlign: 'center',
    },
    text: {
        textAlign: 'justify',
    },

    underlined: {
        textDecoration: 'underline',
    },
    mailingInfo: {
        fontSize: 10,
        fontFamily: 'Helvetica',
    },
    exhibitHeading: {
        textAlign: 'center',
        fontSize: 12,
        fontWeight: 'bold',
    },
    acknowledgementHeading: {
        textAlign: 'center',
        fontSize: '13pt',
    },
    leaseHeading: {
        textAlign: 'center',
        fontSize: 20,
        fontFamily: 'Helvetica-Bold',
    },
    singleLine: {
        borderTop: '1px solid black',
    },
    doubleLines: {
        borderTop: '1px solid black',
        borderBottom: '1px solid black',
    },
    lineHeight: {
        lineHeight: 1.25,
    },
    h2: {
        fontSize: 12,
    },
    h3: {
        fontSize: '12pt',
    },
    lessorLabel: {
        width: '75px',
        fontSize: 9,
        textAlign: 'right',
        marginRight: '4',
        fontWeight: 'bold',
    },
    lessorData: {
        maxWidth: '20%',
        fontSize: 9,
    },
    footerText: {
        color: 'grey',
        fontSize: 9,
    },
    ownershipColumn: {
        width: '14%',
        fontSize: 9,
        textAlign: 'right',
    },
    bonusColumn: {
        width: '14%',
        fontSize: 9,
        textAlign: 'right',
        paddingRight: 15,
    },
    dudleyInfo: {
        position: 'absolute',
        bottom: '50px',
        left: '70px',
    },
    sbTitle: {
        textAlign: 'center',
        marginBottom: 10,
    },
});

interface IBrineMemoProps {
    hideDialog?: () => void;
    // TODO: Update IContract to include these missing fields.
    leaseProps?: SaltwerxBrineLeaseProps;
}

const BrineMemo = (props: IBrineMemoProps) => {
    const dispatch = useDispatch();
    // const [primaryUnitType, setPrimaryUnitType] = useState<string>('');

    // useEffect(() => {
    //     if (props?.measurementTypes?.length > 0) {
    //         let mType = props.measurementTypes.find(mt => mt.id === props?.leaseData?.brineLeaseHolds[0]?.primaryUnitTypeId);
    //         setPrimaryUnitType(mType ? mType.name.toLowerCase() : '');
    //     }
    // }, [props]);

    // const leaseDescription = () => {
    //     const legalDescription: string = !!props?.leaseData ? props?.leaseData?.legalDescription : '';

    //     if (!legalDescription) {
    //         return <Text style={{ fontSize: 9 }}>No Legal Description Available</Text>;
    //     }

    //     if (legalDescription.length >= 1000) {
    //         return (
    //             <Text style={{ fontSize: '10pt', marginTop: '10px', textAlign: 'center' }}>
    //                 "SEE ATTACHED EXHIBIT "A" FOR LEGAL DESCRIPTION"
    //             </Text>
    //         );
    //     } else {
    //         return (
    //             <>
    //                 <Text style={[styles.bold]}>{legalDescription}</Text>
    //             </>
    //         );
    //     }
    // };

    // const termValDisplay = (mode: string): string => {
    //     if (mode === 'normal') {
    //         let primaryTerm: number = !!props?.leaseData ? parseInt(props?.leaseData?.brineLeaseHolds[0]?.primaryRentalTerm + '', 10) : undefined;
    //         let primaryTermUnits: string = primaryUnitType;

    //         if (!primaryTerm && !primaryTermUnits) {
    //             return 'Zero (0) Years';
    //         }

    //         let primaryTermString = MathUtil.numberToEnglish(primaryTerm, ' ');

    //         return `${primaryTermString.charAt(2).toUpperCase() + primaryTermString.slice(3)} (${primaryTerm}) ${primaryTermUnits.charAt(0).toUpperCase() + primaryTermUnits.slice(1)
    //             }`;
    //     }

    //     if (mode === 'option') {
    //         let optionTerm: number = !!props?.leaseData ? parseInt(props?.leaseData?.leasehold?.optionTerm + '', 10) : undefined;
    //         let optionTermUnits: string = !!props?.leaseData ? props?.leaseData?.leasehold?.optionTermUnits : undefined;
    //         if (!optionTerm && !optionTermUnits) {
    //             return 'Zero (0) Years';
    //         }

    //         let optionTermString = MathUtil.numberToEnglish(optionTerm, ' ');

    //         return `${optionTermString.charAt(2).toUpperCase() + optionTermString.slice(3)} (${optionTerm}) ${optionTermUnits.charAt(0).toUpperCase() + optionTermUnits.slice(1)
    //             }`;
    //     }

    //     return '';
    // };

    // const optionToExtend = () => {
    //     if (!!props?.leaseData?.leasehold?.optionExercised) {
    //         return `, with an option to extend for an additional ${termValDisplay('option')}`;
    //     } else {
    //         return '';
    //     }
    // };

    // const displaySignatureBlocks = () => {
    //     return !!props?.leaseData
    //         ? props?.leaseData?.acknowledgements?.map((la: Acknowledgement) => {
    //             return (
    //                 la.signatureBlocks.length > 0 &&
    //                 la.signatureBlocks.map((sb: SignatureBlock, index: number) => {
    //                     return (
    //                         <View key={index} wrap={false} style={styles.mt1}>
    //                             {!!sb.title && sb?.title.length > 0 && (
    //                                 <Text style={[styles.fontNormal, styles.mt1, styles.text, styles.bold]}>{sb?.title}</Text>
    //                             )}
    //                             {/* <Text style={[styles.fontNormal, styles.mt1, styles.text]}>Lessor:</Text> */}
    //                             <Text style={[styles.fontNormal, styles.mt4, styles.text, styles.bold]}>____________________________________</Text>
    //                             <Text style={[styles.fontNormal, styles.text]}>{sb.ownerName}</Text>
    //                         </View>
    //                     );
    //                 })
    //             );
    //         })
    //         : [];
    // };

    // const displayAcknowledgements = () => {
    //     return !!props?.leaseData
    //         ? props?.leaseData?.acknowledgements?.map((la: Acknowledgement, index: number) => {
    //             return (
    //                 <View key={index} wrap={false} style={styles.mt2}>
    //                     <Text style={[styles.fontNormal, styles.mt2]}>{la.text}</Text>
    //                 </View>
    //             );
    //         })
    //         : [];
    // };

    // const additionalProvisions = () => {
    //     let additionalProvisionNumber: number = 0;
    //     let renderClauses: ContractAddendumClause[] = [];
    //     let leaseClauses: ContractAddendumClause[] = !!props?.leaseData && props?.leaseData?.contractClauses;

    //     leaseClauses?.forEach((llc: AnyObject, index: number) => {
    //         let clause: ContractAddendumClause = !!props?.leaseClauses
    //             ? props?.leaseClauses.find((lc) => lc.id === llc.contractAddendumClauseId)
    //             : undefined;

    //         if (!!clause) {
    //             renderClauses.push(clause);
    //         }
    //     });

    //     return renderClauses?.map((rc: ContractAddendumClause, index: number) => {
    //         additionalProvisionNumber++;
    //         return (
    //             <Text key={index} style={[styles.fontNormal, styles.mt2, styles.text]}>
    //                 {additionalProvisionNumber}) {`${rc.leaseClauseType}: ${rc.clauseText}`}
    //             </Text>
    //         );
    //     });
    // };

    // const adhocProvisions = () => {
    //     let additionalProvisionNumber: number = 0;

    //     return (
    //         !!props?.leaseData &&
    //         props?.leaseData?.adHocClauses?.map((lc: LeaseClause, index: number) => {
    //             let type: string = !!props?.leaseClauseTypes ? props?.leaseClauseTypes?.find((lct) => lct.id === lc.leaseClauseTypeId)?.name : '';

    //             additionalProvisionNumber++;
    //             return (
    //                 <Text key={index} style={[styles.fontNormal, styles.mt2, styles.text]}>
    //                     {additionalProvisionNumber + ')'} {`${type}: ${lc.clauseText}`}
    //                 </Text>
    //             );
    //         })
    //     );
    // };

    // const renderAcknowledgementAndSignaturePage = () => {
    //     return !props?.leaseData ? (
    //         <></>
    //     ) : props?.leaseData?.acknowledgements?.length > 0 ? (
    //         <View>
    //             <Text style={[styles.fontNormal, styles.mt3, styles.mb1, styles.h2, styles.bold, styles.text]}>
    //                 IN WITNESS WHEREOF, the parties hereto have caused this Memorandum of Oil and Gas Lease to be effective on the date of first above
    //                 written.
    //             </Text>
    //             <View
    //                 style={{
    //                     display: 'flex',
    //                     flexDirection: 'row',
    //                     justifyContent: 'space-between',
    //                     alignItems: 'center',
    //                     flexWrap: 'wrap',
    //                 }}
    //             >
    //                 {displaySignatureBlocks()}
    //             </View>

    //             <Text style={[styles.acknowledgementHeading, styles.mt4, styles.bold]}>(ACKNOWLEDGMENT)</Text>
    //             {displayAcknowledgements()}
    //         </View>
    //     ) : (
    //         <></>
    //         );
    // };

    // const legalToExhibit = () => {
    //     return !props?.leaseData ? (
    //         <></>
    //         ) : props?.leaseData?.legalDescription.length > 1000 ? (
    //             <View break={true}>
    //             <Text style={[styles.exhibitHeading, styles.bold]}>Exhibit "A"</Text>
    //             <Text style={[styles.fontNormal, styles.mt1, styles.text]}>Attached to and made part of that certain Memorandum of Paid Up Oil and Gas Lease dated{' '} 
    //             <Text style={[styles.bold]}>{moment(props?.leaseData?.effectiveDate).format('MMMM DD, YYYY')}</Text>, 
    //                 by and between{' '} <Text style={[styles.bold, styles.mt1, styles.text]}>{props?.leaseData?.ownersOnDocument}</Text>
    //                 , as Lessor, and{' '} <Text style={[styles.bold, styles.mt1, styles.text]}>{props?.leaseData?.lesseeName}</Text>, as Lessee.
    //             </Text>
    //             <Text style={[styles.mt2, { fontSize: '11.5pt' }, styles.bold]}>LEGAL DESCRIPTION:</Text>
    //             <Text style={[styles.fontNormal, styles.mt1, styles.text]}>{props?.leaseData?.legalDescription}</Text>
    //         </View>
    //     ) : (
    //         <></>
    //         );
    //     };

    // const afterRecording = () => {
    //     return (
    //         <View style={[styles.dudleyInfo, styles.fontNormal]} fixed={true}>
    //             <View>
    //                 <Text style={[styles.bold, styles.h3]}>After Recording, please return to:</Text>
    //                 <Text style={{ fontSize: 10 }}>NewPenn Exploration, LLC</Text>
    //                 <Text style={{ fontSize: 10 }}>817 Avenue A</Text>
    //                 <Text style={{ fontSize: 10 }}>
    //                     Katy, Texas 77493 {'      '} DLC LPR#{props?.leaseData?.leaseNumber}
    //                 </Text>
    //             </View>
    //         </View>
    //     );
    // };

    // const displayExhibits = () => {
    //     return !props?.leaseData ? (
    //         <></>
    //     ) : props?.leaseData?.adHocClauses.length > 0 ? (
    //         <Page size="LEGAL" style={styles.page}>
    //             <Text style={styles.exhibitHeading}>Exhibit {props?.leaseData?.legalDescription.length > 1000 ? 'B' : 'A'}</Text>
    //             <Text style={[styles.fontNormal, styles.mt3, styles.h2]}>Additional Provisions</Text>
    //             {adhocProvisions()}
    //             {additionalProvisions()}
    //             <Text style={styles.pageNumbers} render={({ pageNumber }) => `${pageNumber}`} fixed={true} />
    //         </Page>
    //     ) : (
    //         <></>
    //     );
    // };

    return (
        <Dialog title="MEMO" dialogName={DialogList.MEMO_VIEWER} onCloseDialog={() => dispatch(actions.layout.hideDialog())}>
            <ReactPDF.PDFViewer style={{ height: '85vh', width: '70vw' }}>
                <Document>
                    <Page size="LETTER" style={styles.pageMain}>
                        <View>
                            <View>
                                <Text style={[styles.mt0, { fontSize: '8pt' }]}>
                                    Prepared by: {'\n'}
                                    ExxonMobil Corporation {'\n'}
                                    22777 Springwoods Village Parkway {'\n'}
                                    Spring, TX 77389-1425
                                </Text>
                            </View>

                            <View style={{ marginTop: '30px' }}>
                                <Text
                                    style={{
                                        fontSize: '16pt',
                                        textDecorationStyle: 'solid',
                                        textAlign: 'center',
                                        fontFamily: 'Helvetica-Bold',
                                    }}
                                >
                                    MEMORANDUM GIVING NOTICE OF LEASE
                                </Text>
                            </View>

                            <View style={{ marginTop: '30px' }}>
                                <Text
                                    style={{
                                        fontSize: '10pt',
                                        textDecorationStyle: 'solid',
                                        textAlign: 'left',
                                    }}
                                >
                                    STATE OF <Text style={{fontFamily: 'Arial-Bold'}}>ARKANSAS{'\n'}</Text>
                                    COUNTY OF {props.leaseProps.locationCountiesUpper}
                                </Text>
                            </View>

                            <View style={{ marginTop: '10px' }}>
                                <Text
                                    style={{
                                        fontSize: '10pt',
                                        textDecorationStyle: 'solid',
                                        textAlign: 'left',
                                    }}
                                >
                                    KNOW ALL MEN BY THESE PRESENTS:
                                </Text>
                            </View>

                            {/* <View
                                style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                    justifyContent: 'flex-start',
                                    marginTop: '10px',
                                }}
                            >
                                <View>
                                    <Text style={{ fontSize: 9, fontFamily: 'Times-Bold' }}>
                                        STATE OF {!!props?.location ? props?.location?.state?.toUpperCase() : '______'}
                                    </Text>
                                    <Text style={{ fontSize: 9, marginTop: '10px', fontFamily: 'Times-Bold' }}>
                                        COUNTY OF {!!props?.location ? props?.location?.counties[0]?.toUpperCase() : '___________'}
                                    </Text>
                                </View>
                                <View style={{ marginLeft: '30px' }}>
                                    <Text style={{ fontSize: 9 }}>§</Text>
                                    <Text style={{ fontSize: 9 }}>§</Text>
                                    <Text style={{ fontSize: 9 }}>§</Text>
                                </View>
                            </View> */}
                        </View>

                        <View>
                            <View style={{ marginTop: '15px' }}>
                                <Text style={[{textAlign: 'justify'}, styles.fontNormal, styles.lineHeight]}>
                                    <Text style={{ fontFamily: 'Arial-Bold' }}>WHEREAS, </Text>
                                    <Text>{props?.leaseProps?.lesseeName}</Text>, whose address is
                                    <Text>{' '}{props.leaseProps.lesseeAddress}</Text> (hereinafter called Lessor) and{' '}
                                    <Text>{'Saltwerx LLC'}</Text>, whose address is 22777 Springwoods Village Parkway, Spring, Texas 77389-1425, 
                                    (hereinafter called Lessee) have entered into a Mineral Lease dated the <Text>{props.leaseProps.longLeaseDate}</Text>
                                    <Text>{ }</Text> (the Lease), and; {' '}{'\n\n'}
                                </Text>
                            </View>

                            <View style={[styles.mt0]}>
                                <Text style={[styles.fontNormal, styles.lineHeight]}>
                                    <Text style={[styles.indent, {fontFamily: 'Helvetica-Bold' }]}>WHEREAS, </Text> 
                                    the Lessee and Lessor have mutually agreed not to record the Lease in its
                                    entirety in the records of {props.leaseProps.locationCounties} County, Arkansas, and instead have agreed to record this
                                    Memorandum of Lease;{'\n\n'}
                                </Text>
                            </View>

                            <View>
                                <Text style={[{ textAlign: 'justify'}, styles.fontNormal, styles.lineHeight]}>
                                    <Text style={[styles.indent, { fontFamily: 'Helvetica-Bold' }]}>NOW, THEREFORE, </Text> 
                                    in consideration of the valuable consideration given this date, the
                                    receipt and sufficiency of which is hereby acknowledged, and of the other terms of the Lease,
                                    duplicate copies of which have been retained by the parties, Lessor hereby grants, leases, and
                                    lets unto the Lessee for the purpose of exploring, drilling, operating for and producing the minerals
                                    from the following described land in {props.leaseProps.locationCounties} County, Arkansas:
                                </Text>
                            </View>

                            <View style={{ marginTop: '10px' }}>
                                <Text style={[styles.mt1, styles.fontNormal, styles.underlined, { textAlign: 'center' }]}>{'Township '}{props.leaseProps.includedTract.township}.{' Range '}{props.leaseProps.includedTract.range}</Text>
                                <Text style={[styles.fontNormal, { textAlign: 'center' }]}>{'Section '}{props.leaseProps.includedTract.sectionNumber}{': \n'}{props.leaseProps.includedTract.legalDescription}</Text>
                            </View>

                            <View style={{ marginTop: '15px' }}>
                                <Text style={[styles.fontNormal, styles.lineHeight]}>
                                    and containing {props.leaseProps.grossAcres} acres, more or less.{'\n\n'}
                                </Text>
                            </View>

                            <View style={{ marginTop: '15px' }}>
                                <Text style={[{textAlign: 'justify'}, styles.indent, styles.fontNormal, styles.lineHeight]}>
                                    All in accordance with the terms and conditions of the Lease, the Lease shall be effective
                                    for a term of five (5) years from the date of the Lease and as long thereafter as Brine or other
                                    substances covered thereby are produced from said land. Further, Lessee has the right to extend
                                    the lease for twenty (20) additional one (1) year terms by paying the annual rental payments
                                    as specified in the Lease. Should there be any conflict between this Memorandum of Lease and
                                    the Lease herein referred to, then in all cases the Lease shall take precedence. In addition, in the
                                    event of a conflict between the terms of an addendum to the said Lease and the terms of the
                                    printed Lease form, the terms of an addendum to said Lease shall prevail.
                                </Text>
                            </View>

                            <View style={{ marginTop: '15px' }}>
                                <Text style={[styles.indent, styles.fontNormal, styles.lineHeight]}>
                                    The provisions hereof shall extend to and be binding upon the heirs, successors and legal
                                    representatives and assigns of the parties hereto.
                                </Text>
                            </View>

                            <View style={{ marginTop: '15px' }}>
                                <Text style={[{textAlign: 'justify'}, styles.indent, styles.fontNormal, styles.lineHeight]}>
                                    This instrument may be executed in any number of counterparts, each of which shall be deemed an original and shall be
                                    binding upon the party or parties so executing, their heirs,
                                    successors and assigns, and all of which when taken together constitute but one and the same instrument.
                                </Text>
                            </View>

                            <View style={{ marginTop: '15px' }}>
                                <Text style={[{textAlign: 'justify'}, styles.fontNormal, styles.lineHeight]}>
                                    IN WITNESS WHEREOF, this instrument is executed as of the date hereinbefore first mentioned,
                                    which date shall be the basis for ascertaining the first and each succeeding anniversary date of
                                    the execution of this lease.
                                </Text>
                            </View>
                        </View>

                        <View break={true}>
                            <View style={{ marginTop: '100px' }}>
                                <Text style={[styles.fontNormal, styles.lineHeight]}>
                                    <Text style={{ fontFamily: 'Arial-Bold' }}>EXECUTED </Text>
                                    this {props.leaseProps.longEffectiveDate}
                                </Text>
                            </View>

                            <View style={{ marginTop: '70px', marginLeft: '50%' }}>
                                <Text style={[styles.fontNormal, styles.lineHeight]}>
                                    {props?.leaseProps?.ownersOnDocument}
                                </Text>
                                <Text style={{ fontSize: '10pt', marginTop: '60px' }}>
                                ________________________________
                                </Text>
                                <Text style={[styles.fontNormal, styles.lineHeight]}>
                                    {props?.leaseProps?.lessorAka} {'\n\n\n'}
                                </Text>
                            </View>

                            <View style={{ marginTop: '15px' }}>
                                <Text style={[styles.fontNormal, styles.lineHeight]}>
                                    <Text style={{ fontFamily: 'Helvetica-Bold', textDecoration: 'underline', textAlign: 'center' }}>
                                        ACKNOWLEDGEMENT{'\n\n'}</Text>
                                    <Text>State of ________________{'\n\n'}</Text> 
                                    <Text>County of ______________ </Text>
                                </Text>
                            </View>

                            <View style={{ marginTop: '15px' }}>
                                <Text style={[{textAlign: 'justify'}, styles.indent, styles.fontNormal, styles.lineHeight]}>
                                    BE IT REMEMBERED, that on this day came and appeared in person before me, the
                                    undersigned, a Notary Public in and for the County and State aforesaid, duly commissioned and
                                    acting, {props?.leaseProps?.ownersOnDocument}, to me well known as the Lessor
                                    (whether one or more) whose name is subscribed to the foregoing instrument of writing, and
                                    stated that said Lessor had executed the same for the consideration and purposes therein
                                    mentioned and set forth.
                                </Text>
                            </View>

                            <View style={{ marginTop: '15px' }}>
                                <Text style={[styles.indent, styles.fontNormal, styles.lineHeight]}>
                                    WITNESS MY HAND AND SEAL AS SUCH Notary Public on this the _______ day of ____________, {props.leaseProps.currentDate}
                                </Text>
                            </View>

                            <View style={{ marginTop: '15px', marginLeft: '50%' }}>
                                <Text style={{ fontSize: '9pt' }}>
                                _________________________________________
                                </Text>
                                <Text style={{ fontSize: '9pt' }}>
                                    Notary Public
                                </Text>
                            </View>

                            <View>
                                <Text style={{ fontSize: '9pt' }}>
                                    My Commission Expires:
                                </Text>
                                <Text style={{ fontSize: '9pt', marginLeft: '50%' }}>
                                _________________________________________
                                </Text>
                                <Text style={{ fontSize: '9pt', marginLeft: '50%', marginTop: '10px'}}>
                                    Notary's Printed Name
                                </Text>
                                <Text style={{ fontSize: '9pt'}}>
                                _____________________
                                </Text>
                            </View>
                        </View>

                        {/* <View style={[styles.dudleyInfo, styles.fontNormal]} fixed={true}>
                            <View>
                                <Text style={[styles.bold, styles.h3]}>After Recording, please return to:</Text>
                                <Text style={{ fontSize: 10 }}>NewPenn Exploration, LLC</Text>
                                <Text style={{ fontSize: 10 }}>817 Avenue A</Text>
                                <Text style={{ fontSize: 10 }}>
                                    Katy, Texas 77493 {'      '} DLC LPR#{props?.leaseData?.leaseNumber}
                                </Text>
                            </View>
                        </View> */}

                        <Text style={styles.pageNumbers} render={({ pageNumber }) => `${pageNumber}`} fixed={true} />
                    </Page>

                    {/* Functions to render pages based on if there are items to render or other logic */}
                    {/* <Page size="LEGAL" style={styles.page} break={true}>
                        {renderAcknowledgementAndSignaturePage()}
                        {legalToExhibit()}
                        {afterRecording()}
                        {{displayExhibits()} }
                        <Text style={styles.pageNumbers} render={({ pageNumber }) => `${pageNumber}`} fixed={true} />
                    </Page>
                     */}
                </Document>
            </ReactPDF.PDFViewer>
        </Dialog>
    );
};

export default BrineMemo;



// WEBPACK FOOTER //
// ./src/components/project/sections/LeasingComponents/MemoTemplates/BrineMemo.tsx